export const QUERY_KEYS = {
  isLoggedIn: "isLoggedIn",
  productList: "productList",
  clientList: "clientList",
  transactionList: "transactionList",
  expenseList: "expenseList",
};
